export default  {
    name: state => state.info.name,
    avatar: state => state.info.avatar,
    companyname: state => state.info.companyname,
    vip_type: state=> state.info.vip_type,
    vip_log: state=> state.info.vip_log,
}
